import React from 'react';
import { useTranslation } from '../i18n/LocaleContext';

const VERSION = '1.2.4';

const VersionFooter = () => {
  const { t } = useTranslation();
  return (
    <p className="max-w-md mx-auto py-5 text-center text-[11px] text-ink-muted">
      LikeUp · {t('versionFooter')} {VERSION}
    </p>
  );
};

export default VersionFooter;
